import React, { useEffect, useState } from 'react'
import { useStore, useDispatch } from 'react-redux'
import { Redirect, Link } from "react-router-dom"
//--- actions ---
import { doLogin } from '../../redux/actions/auth'
import { doGetDomainsByUserId, doGetJoinedDomainsByUserId } from '../../redux/actions/domain'

//--- layouts & components ---
import LoginLayout from '../../layout/LoginLayout'
import LoaderComponent from '../../components/CommonComponents/LoaderComponent'
import CheckboxComponent from '../../components/CommonComponents/CheckboxComponent'
import DomainSelector from './domain'
import LeftImageComponent from '../../components/CommonComponents/LeftImageComponent'
import Image from '../../assets/img/signin.png'
import {AiOutlineMail } from 'react-icons/ai'
import {RiErrorWarningLine } from 'react-icons/ri'
import { BsEye, BsEyeSlash } from "react-icons/bs";
import { emailValidator } from '../../utils/validator'

const LoginPage = () => {
  const dispatch = useDispatch()
  const store = useStore().getState()
  const {
    auth: { isLoggedIn, user, token, isLoading },
  } = store

  const [emailValues, setEmail] = useState({
    email : '',
    emailerror : ''
  })
  const [passwordValues, setPassword] = useState({
    password : '',
    showPassword : false,
    pwderror : ''
  })
  const [isLoggedSucceed, setIsLoggedSucceed] = useState(false)

  useEffect(() => {
    if (!user || !token) {
      setPassword({...passwordValues, password:''})
      setEmail({...emailValues, email:''})
      return
    }
    dispatch(doGetDomainsByUserId())
    dispatch(doGetJoinedDomainsByUserId())
  }, [dispatch, user, token])

  const onLogin = () => {
    if (!emailValues.email) {
      emailValues.emailerror = 'Email should not be empty!'
    } else {
      if (!emailValidator(emailValues.email)) {
        emailValues.emailerror = 'This email is invalid'
      } else {
        emailValues.emailerror = ''
      }
    }
    if (!passwordValues.password) {
      passwordValues.pwderror = 'Password should not be empty!';
    } else {
      passwordValues.pwderror = '';
    }

    if (passwordValues.pwderror === '' && emailValues.emailerror === '') {
      dispatch(
        doLogin({
          email: emailValues.email,
          password: passwordValues.password,
        })
      ).then(() => {
        localStorage.setItem('loginStep', 'domain')
        setIsLoggedSucceed(true)
      }).catch((err) => {
        console.log(err.response)
      })
    } else {
      setPassword({...passwordValues})
      setEmail({...emailValues})
    }
  }

  const handleKeyDown = (e) => {
    if (e.which === 13) {
      onLogin()
    }
  }

  if (isLoggedIn) {
    localStorage.removeItem('loginStep')
    return (
      <Redirect
        to='/dashboard'
      />
    )
  }

  const showPassword = () => {
    setPassword({...passwordValues, showPassword: !passwordValues.showPassword})
  }

  const handleInputChange = (prop) => (event) =>  {
    if (prop === 'email') {
      if (emailValues.email) {
        if (!emailValidator(emailValues.email)) {
          emailValues.emailerror = 'This email is invalid'
        } else {
          emailValues.emailerror = ''
        }
      }
      setEmail({...emailValues, [prop] : event.target.value})
    } else {
      if (passwordValues.password) {
        passwordValues.pwderror = ''
      }
      setPassword({ ...passwordValues, [prop] : event.target.value });
    }
  }

  return (
    <LoginLayout>
      <div className={`login-page d-sm-flex d-flex flex-sm-column flex-column flex-lg-row ${(isLoggedSucceed || localStorage.getItem('loginStep') === 'domain') ? 'd-lg-inline' : ''}`}>
      {
        !localStorage.getItem('loginStep') && (
        <>
        <div className='login-left'>
          <LeftImageComponent image={Image} quote="A User Friendly Software with Exceptional Customer Support" quoteby="-Kristi H, Denver, US"/>
        </div>
        <div className={`login-right ${isLoading && 'loading'}`}>
          { isLoading && <LoaderComponent /> }
          {/* {
            !localStorage.getItem('loginStep') && ( */}
              <div className="form-content">
                <div className="form-title">
                  <h4>Sign in</h4>
                  {
                    (isLoggedSucceed &&
                      <span>Don't have an Account? <Link to="/signup">Sign up</Link></span>
                    )
                  }
                </div>
                <div className="form-input-container">
                  <div className={`form-input-inner ${emailValues.emailerror ? '' : 'has-bottom-margin'}`}>
                    <div className='form-input'>
                      <input className={`${emailValues.emailerror ? 'error-border' : ''}`} type="text" placeholder="Email Address" value={emailValues.email} onChange={handleInputChange('email')} onKeyDown={handleKeyDown} />
                      <AiOutlineMail color="#104569" size={24} />
                    </div>
                    {emailValues.emailerror && (
                      <div className='error-container flex align-center'>
                        <RiErrorWarningLine className='mb-2' color="#F75A52" size={15} />
                        <p className='error mb-2'>{emailValues.emailerror}</p>
                      </div>
                    )}
                  </div>
                  <div className={`form-input-inner ${passwordValues.pwderror ? '' : 'has-bottom-margin'}`}>
                    <div className='form-input'>
                      <input className={`${passwordValues.pwderror ? 'error-border' : ''}`} type={passwordValues.showPassword ? "text" : "password"} placeholder="Type Password" value={passwordValues.password} onChange={handleInputChange('password')} onKeyDown={handleKeyDown} />
                      {passwordValues.showPassword ? 
                        <BsEye color="#104569" size={24} onClick={showPassword}/> :
                        <BsEyeSlash color="#104569" size={24} onClick={showPassword}/>
                      }
                    </div>
                    {passwordValues.pwderror && (
                      <div className='error-container flex align-center'>
                        <RiErrorWarningLine className='mb-2' color="#F75A52" size={15} />
                        <p className='error mb-2'>{passwordValues.pwderror}</p>
                      </div>
                    )}
                  </div>
                  
                  <CheckboxComponent label="Remember me" />
                  <button type="button" className="btn-login" onClick={onLogin}>Sign in</button>
                  <Link to="/forgotpassword" className="link-forgot">Forgot your password?</Link>
                </div>
              </div>
              {/* )
            }
           {
            (isLoggedSucceed || localStorage.getItem('loginStep') === 'domain') && (
              <DomainSelector />
            )
          } */}
          <div className='privacy-copyright-container d-flex justify-content-between h-100 w-100 align-items-end'>
            <span className='h3'> Privacy Policy </span>
            <span className='h3'> Copyright 2022 </span>
          </div>
        </div>
        </>
        )
      }
        {
            (isLoggedSucceed || localStorage.getItem('loginStep') === 'domain') && (
              <DomainSelector />
            )
          }
      </div>
    </LoginLayout>
  )
}

export default LoginPage
